import { createCacheStore } from '@lib/utils/cache';
import { EmployeeService } from '@api/EmployeeService';
import { PatternCase } from '@lib/utils';

/** Cached EmployeeService.getEmployees(departmentId) reads. */
export const employeesCache = createCacheStore(
    'employee/employees',
    EmployeeService.getEmployees,
);

/** Cached EmployeeService.getEmployee(departmentId, employeeId) reads. */
export const employeeCache = createCacheStore(
    'employee/employee',
    EmployeeService.getEmployee,
);

/*
 * The plain list and the planner's all-patterns projection
 * share the employee data, so both entries must go.
 */
export const invalidateEmployees = (departmentId: string): void => {
    employeesCache.invalidate(departmentId);
    employeesCache.invalidate(departmentId, PatternCase.ALL_PATTERNS);
};

/** Drops the cached detail of one employee (after employee mutations). */
export const invalidateEmployee = (
    departmentId: string,
    employeeId: string,
): void => {
    employeeCache.invalidate(departmentId, employeeId);
};

/** Drops all cached employee data (department switch, full clears). */
export const invalidateEmployeeData = (): void => {
    employeesCache.invalidateAll();
    employeeCache.invalidateAll();
};
